var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function pick(obj) {
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        return keys.reduce(function (s, k) {
            var _a;
            return (__assign({}, s, (_a = {}, _a[k] = obj[k], _a)));
        }, {});
    }
    exports.pick = pick;
    function merge(target, src) {
        var keys = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            keys[_i - 2] = arguments[_i];
        }
        return keys.reduce(function (s, k) {
            if (src[k]) {
                s[k] = src[k];
            }
            return s;
        }, target);
    }
    exports.merge = merge;
    function skip(target, src) {
        var keys = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            keys[_i - 2] = arguments[_i];
        }
        return Object.keys(src).filter(function (x) { return keys.indexOf(x) < 0; }).reduce(function (cur, k) {
            var _a;
            return $.extend(cur, (_a = {}, _a[k] = src[k], _a));
        }, target);
    }
    exports.skip = skip;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/object.js
// module id = 47
// module chunks = 0